//export const API_URL = 'http://localhost:8080/api'
export const API_URL = 'https://api.employee.l3s.ru/api';